// Lib
import { createSelector } from 'reselect';

// Utils
import { getLastCheckedNotifications } from '../../../../../common/users/utils/userPropertyUtils';

// Selectors
import {
    getHasMoreNotificationsSelector,
    getNotificationsSelector,
    hasNotificationsFetchErrorSelector,
    isFetchedNotificationsSelector,
    isFetchingNotificationsSelector,
} from '../../../../notifications/notificationsSelector';
import { getCurrentUser } from '../../../../user/currentUserSelector';
import { notificationGroupSelector } from './groups/notificationsGroupsSelector';
import { getGroupTimestamp, getGroupUnseen } from './groups/notificationGroupUtils';
import { areBoardHierarchiesInitialised } from '../../../../app/initialisation/initialisationSelector';

export const newNotificationsCountSelector = createSelector(
    // This is used so the count shows at the same time as the board activity indicators
    areBoardHierarchiesInitialised,
    getCurrentUser,
    notificationGroupSelector,
    (isReady, currentUser, notificationGroups) => {
        if (!isReady) return 0;

        const lastCheckedNotifications = getLastCheckedNotifications(currentUser);

        const newNotifications = notificationGroups.filter(
            (group) => getGroupTimestamp(group) >= lastCheckedNotifications && !!getGroupUnseen(group),
        );

        return newNotifications.length || 0;
    },
);

export default createSelector(
    getNotificationsSelector,
    getHasMoreNotificationsSelector,
    notificationGroupSelector,
    newNotificationsCountSelector,
    getCurrentUser,
    isFetchingNotificationsSelector,
    isFetchedNotificationsSelector,
    hasNotificationsFetchErrorSelector,
    (
        notifications,
        hasMore,
        notificationGroups,
        newNotificationsCount,
        currentUser,
        isFetchingNotifications,
        isFetchedNotifications,
        hasNotificationsFetchError,
    ) => ({
        notifications,
        notificationGroups,
        hasMore,
        newNotificationsCount,
        isFetchingNotifications,
        isFetchedNotifications,
        hasNotificationsFetchError,
        lastCheckedNotifications: getLastCheckedNotifications(currentUser),
        currentUser,
    }),
);
